import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getDepartamentos,
  insertDepartamento,
  updateDepartamento,
  deleteDepartamento,
  getDepartamentoById,
} from 'services/usuario'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_DEPARTAMENTOS() {
  try {
    const departamentosData = yield call(getDepartamentos)
    if (departamentosData.ok) {
      yield put({
        type: actions.DEPARTAMENTOS_LOAD_SUCCEEDED,
        payload: departamentosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Departamentos')
      put({
        type: actions.DEPARTAMENTOS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.DEPARTAMENTOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_DEPARTAMENTO(action) {
  try {
    const departamentoObj = yield call(insertDepartamento, action.payload)
    if (departamentoObj.ok) {
      putMessage(messageType.SUCCESS, 'Departamento creado correctamente')
      yield put({
        type: actions.DEPARTAMENTO_INSERT_SUCCEEDED,
        payload: departamentoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Departamento')
      yield put({
        type: actions.DEPARTAMENTO_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Departamento')
    yield all([
      put({
        type: actions.DEPARTAMENTO_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_DEPARTAMENTO(action) {
  try {
    const departamentoObj = yield call(updateDepartamento, action.payload)
    if (departamentoObj.ok) {
      putMessage(messageType.SUCCESS, 'Departamento modificado correctamente')
      yield put({
        type: actions.DEPARTAMENTO_UPDATE_SUCCEEDED,
        payload: departamentoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Departamento')
      yield put({
        type: actions.DEPARTAMENTO_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Departamento')
    yield all([
      put({
        type: actions.DEPARTAMENTO_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_DEPARTAMENTO(action) {
  try {
    const DepartamentoResult = yield call(deleteDepartamento, action.payload)
    if (DepartamentoResult.ok) {
      putMessage(messageType.SUCCESS, 'Departamento eliminado correctamente')
      yield put({
        type: actions.DEPARTAMENTO_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Departamento')
      yield put({
        type: actions.DEPARTAMENTO_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Departamento')
    yield all([
      put({
        type: actions.DEPARTAMENTO_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_DEPARTAMENTO_BY_ID(action) {
  try {
    const DepartamentoData = yield call(getDepartamentoById, action.payload)
    if (DepartamentoData.ok) {
      yield put({
        type: actions.DEPARTAMENTO_LOAD_BY_ID_SUCCEEDED,
        payload: DepartamentoData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Departamento')
      put({
        type: actions.DEPARTAMENTO_LOAD_BY_ID_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.DEPARTAMENTO_LOAD_BY_ID_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.DEPARTAMENTOS_LOAD_REQUESTED, GET_DEPARTAMENTOS),
    takeEvery(actions.DEPARTAMENTO_LOAD_BY_ID_REQUESTED, GET_DEPARTAMENTO_BY_ID),
    takeEvery(actions.DEPARTAMENTO_INSERT_REQUESTED, INSERT_DEPARTAMENTO),
    takeEvery(actions.DEPARTAMENTO_UPDATE_REQUESTED, UPDATE_DEPARTAMENTO),
    takeEvery(actions.DEPARTAMENTO_DELETE_REQUESTED, DELETE_DEPARTAMENTO),
  ])
}
